/**
 * Compares two URL query objects structurally, ignoring key order
 * and coercing values to strings (except nested objects, which use JSON).
 */
export function queriesEqual(a, b) {
    const aEmpty = !a || Object.keys(a).length === 0;
    const bEmpty = !b || Object.keys(b).length === 0;

    if (aEmpty && bEmpty) return true;
    if (aEmpty !== bEmpty) return false;

    const aKeys = Object.keys(a).sort();
    const bKeys = Object.keys(b).sort();
    if (aKeys.length !== bKeys.length) return false;
    if (!aKeys.every((k, i) => k === bKeys[i])) return false;

    return aKeys.every(k => {
        const aVal = a[k];
        const bVal = b[k];
        if (typeof aVal === 'object' && aVal !== null) {
            return JSON.stringify(aVal) === JSON.stringify(bVal);
        }
        return String(aVal) === String(bVal);
    });
}
